import type { OnboardingStepItem } from '../../types/onboarding-step.type';

/** 상단 진행 표시 — 끝난 단계(✓) · 지금 단계(번호 강조) · 남은 단계(회색 번호). */
export function OnboardingStepper({
  steps,
  current,
}: {
  steps: OnboardingStepItem[];
  current: string | undefined;
}) {
  return (
    <ol className="flex items-start">
      {steps.map((step, i) => {
        const active = step.key === current;
        return (
          <li
            key={step.key}
            aria-current={active ? 'step' : undefined}
            className="relative flex flex-1 flex-col items-center gap-1.5"
          >
            {/* 앞 단계와 잇는 선 — 원 중심 높이에 깐다. */}
            {i > 0 && (
              <span
                aria-hidden
                className={`absolute right-1/2 top-3.5 h-0.5 w-full -translate-y-1/2 ${
                  step.done || active
                    ? 'bg-brand-700 dark:bg-brand-400'
                    : 'bg-neutral-200 dark:bg-white/10'
                }`}
              />
            )}
            <span
              className={[
                'relative z-10 grid h-7 w-7 place-items-center rounded-full text-xs font-bold transition-colors',
                step.done
                  ? 'bg-brand-700 text-white dark:bg-brand-400 dark:text-dark-base'
                  : active
                    ? 'border-2 border-brand-700 bg-white text-brand-700 dark:border-brand-400 dark:bg-dark-card dark:text-brand-400'
                    : 'border border-neutral-300 bg-white text-neutral-500 dark:border-white/15 dark:bg-dark-card dark:text-neutral-500',
              ].join(' ')}
            >
              {step.done ? (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  aria-hidden
                >
                  <path
                    d="M2.5 6.5L5 9L9.5 3.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                i + 1
              )}
            </span>
            <span
              className={`text-xs ${
                active
                  ? 'font-bold text-neutral-950 dark:text-neutral-100'
                  : 'text-neutral-500 dark:text-neutral-400'
              }`}
            >
              {step.label}
              {step.done && <span className="sr-only"> (완료)</span>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
